// extracted by mini-css-extract-plugin
export var fullHeightState = "_4m-7";
export var headerCell = "_4m-1";
export var loadingStateCell = "_4m-4";
export var rowWrapper = "_4m-3";
export var standaloneTable = "_4m-8";
export var standaloneTableWithBodyFill = "_4m-9";
export var stateCell = "_4m-5";
export var table = "_4m-0";
export var tableBodyFiller = "_4m-6";
export var white = "_4m-2";